import http from './http';

const add = (websiteId, payload) => http.post(`/licence/website/${websiteId}/add`, payload);
const edit = (websiteId, licenceId, payload) => http.put(`/licence/website/${websiteId}/edit/${licenceId}`, payload);
const remove = (websiteId, licenceId) => http.del(`/licence/website/${websiteId}/remove/${licenceId}`);
const list = (websiteId) => http.get(`/licence/website/${websiteId}/list`);
const load = (websiteId, licenceId) => http.get(`/licence/website/${websiteId}/licence/${licenceId}`);

export default { add, edit, remove, list, load };
export { add, edit, remove, list, load };
